export enum NATIVE_ASSET {
  ETHEREUM = 'ETH',
  STELLAR = 'XLM'
}
